import moment from "moment";

interface Project {
  id: string;
  client_name: string;
  firstname?: string;
  lastname?: string;
  preferred_name?: string;
  client_id?: string;
  phone_number?: string;
  email_address?: string;
  start_date: string;
  end_date: string;
}

interface ProjectsMultiselectOption {
  id: string;
  name: string;  // Required by the interface
  client_name: string;
  firstname?: string;
  lastname?: string;
  preferred_name?: string;
  client_id?: string;
  phone_number?: string;
  email_address?: string;
  startDate: string;
  endDate: string;
}

const getProjectDropdownOptions = (
  projects: Project[]
): ProjectsMultiselectOption[] => {
  const dateFormat = "DD MMM YYYY";

  return projects.map(project => {
    const formattedStartDate = project.start_date 
      ? moment(project.start_date).format(dateFormat)
      : '';
    const formattedEndDate = project.end_date 
      ? moment(project.end_date).format(dateFormat)
      : '';

    // Create a display name prioritizing firstname + lastname
    let displayName = project.client_name;
    if (project.firstname && project.lastname) {
      displayName = `${project.firstname} ${project.lastname}`;
    } else if (project.firstname || project.lastname) {
      displayName = project.firstname || project.lastname;
    }

    return {
      id: project.id,
      name: displayName, // Use the best available name for the interface
      client_name: project.client_name,
      firstname: project.firstname,
      lastname: project.lastname,
      preferred_name: project.preferred_name,
      client_id: project.client_id,
      phone_number: project.phone_number,
      email_address: project.email_address,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
  });
};

export default getProjectDropdownOptions;